import React from 'react';
import _classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import useSiteCopySelector from 'components/useSiteCopySelector';
import SupportWidget from 'components/SupportWidget';

const useStyles = makeStyles({
  container: {
    display: 'flex !important',
    justifyContent: 'flex-start',
    marginBottom: 0,
  },
  text: {
    fontWeight: 600,
    textTransform: 'uppercase',
  },
});

const InternalSupportWidget = ({ containerClassName }) => {
  const classes = useStyles();
  const [feedbackWidgetSiteCopy] = useSiteCopySelector(['feedback-widget']);

  const getEmailData = formValues => ({
    ...formValues,
    subject: 'New Support Request',
  });

  return (
    <SupportWidget
      widgetCopy={feedbackWidgetSiteCopy?.pageCopy?.supportWidget}
      getEmailData={getEmailData}
      type="internalSupport"
      containerClassName={_classNames(classes.container, containerClassName)}
      textClassName={classes.text}
    />
  );
};

export default InternalSupportWidget;
